import { useTranslation } from 'react-i18next'

import { ArrowsLeftRightIcon, CoinIcon, PackageIcon } from '@phosphor-icons/react'

import { Button, ButtonWithSpinner, CardTitle, Drawer, FormatPrice, Switch, Text } from '@reveni-io/reveni-ui'

import { getNewLineItemsRequested } from '../NewLineItemsRequestedCard/helpers'
import { getAdjustedPendingAmount, getProductCounts } from './helpers'
import * as Styles from './styles'

const CreateExchangeOrderDrawer = ({
  show,
  onClose,
  onConfirm,
  loading,
  items,
  newItems,
  pendingAmount,
  currency,
  includeCancelled,
  setIncludeCancelled,
}) => {
  const { t } = useTranslation()

  const newLineItemsRequested = getNewLineItemsRequested(items, newItems)
  const { cancelledCount, productsToSendCount } = getProductCounts(newLineItemsRequested, includeCancelled)
  const adjustedPendingAmount = getAdjustedPendingAmount(pendingAmount, newLineItemsRequested, includeCancelled)

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <CardTitle icon={ArrowsLeftRightIcon}>{t('Crear pedido de cambio')}</CardTitle>
      <Styles.Container>
        <Text type="bodyMRegular">{t('Crear pedido de cambio para el envío de los nuevos productos solicitados')}</Text>
        <Styles.InfoRow>
          <PackageIcon size={24} />
          <Text type="bodyMRegular">{productsToSendCount}</Text>
          <Text type="bodyMRegular">{t('productos solicitados por enviar')}</Text>
        </Styles.InfoRow>
        {cancelledCount > 0 && (
          <Styles.InfoRow cancelled={includeCancelled}>
            <PackageIcon size={24} />
            <Text type="bodyMRegular">{cancelledCount}</Text>
            <Text type="bodyMRegular">{t('productos solicitados cancelados')}</Text>
          </Styles.InfoRow>
        )}
        {adjustedPendingAmount > 0 && (
          <Styles.InfoRow>
            <CoinIcon size={24} />
            <Text type="bodyMRegular">
              <FormatPrice currency={currency}>{adjustedPendingAmount}</FormatPrice>
            </Text>
            <Text type="bodyMRegular">{t('pago pendiente')}</Text>
          </Styles.InfoRow>
        )}
        {cancelledCount > 0 && (
          <Switch
            label={t('Incluir productos cancelados en el pedido')}
            checked={includeCancelled}
            onChange={e => setIncludeCancelled(e.target.checked)}
          />
        )}
        <Styles.ActionsContainer>
          <Button onClick={onClose} variant="outlined" fullWidth>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            onClick={() => onConfirm(includeCancelled)}
            defaultLabel={t('Crear pedido')}
            loadingLabel={t('Creando pedido')}
            loading={loading}
            disabled={loading}
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Drawer>
  )
}

export default CreateExchangeOrderDrawer
